export default __webpack_public_path__ + "static/media/O-015.c739e253.png";